<div
  *ngIf="alert"
  class="alert alert-dismissible"
  [ngClass]="{
    'alert-success': alert.alertType === 'success',
    'alert-warning': alert.alertType === 'warning',
    'alert-danger': alert.alertType === 'error'
  }"
  role="alert"
>
  <div class="d-flex">
    <div>
      <ng-container *ngIf="alert.alertType === 'success'">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="icon alert-icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M5 12l5 5l10 -10" />
        </svg>
      </ng-container>
      <ng-container *ngIf="alert.alertType === 'error'">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="icon alert-icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="12" cy="12" r="9" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </ng-container>
      <ng-container *ngIf="alert.alertType === 'warning'">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="icon alert-icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M12 9v2m0 4v.01" />
          <path
            d="M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
          />
        </svg>
      </ng-container>
    </div>
    <div>
      <h4 class="alert-title">{{ alert.mainMessage }}</h4>
      <div *ngIf="alert.subMessage" class="text-secondary">
        {{ alert.subMessage }}
      </div>
    </div>
  </div>
  <a class="btn-close" data-bs-dismiss="alert" aria-label="close"></a>
</div>
